import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.DEFAULT,
    alt: 'college student shipping page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'college student shipping page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'College Student Shipping Services Fast',
  description: '',
  points: [],
  image: {
    url: '/images/v2/pages/landing-pages/shipping-and-storage-services/hero-image.svg',
    alt: 'college student shipping page'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register for Student Shipping' }
}

export const helperGuideSection = {
  title: '',

  ctaBtn: { href: PUBLIC_MAIN_ROUTES.HOW_SHIP_AND_STORAGE_WORKS.href, text: 'Learn More' },
  cards: [
    {
      id: 1,
      title: 'Secure College Student Shipping Services',
      description: '',
      image: {
        src: '/images/v2/pages/landing-pages/shipping-and-storage-services/book-your-service.svg',
        alt: 'Secure College Student Shipping Services service'
      }
    },

    {
      id: 2,
      title: 'Reliable College Shipping Solutions',
      description: '',
      image: {
        src: '/images/v2/pages/landing-pages/shipping-and-storage-services/pickup-and-secure-storage.svg',
        alt: 'Reliable College Shipping Solutions service'
      }
    }
  ]
}

export const evenOddList = {
  title: '',
  description: '',

  articles: [
    {
      id: 1,
      title: 'College Student Shipping Solutions Secure and Fast',
      description:
        'Fast and secure college student shipping services. Affordable, reliable solutions for shipping your belongings safely and efficiently.',
      image: {
        src: '/images/v2/pages/landing-pages/shipping-and-storage-services/business-storage-solution.svg',
        alt: 'College Student Shipping Solutions Secure and Fast'
      },
      link: {
        text: 'Learn More',
        href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href
      }
    }
  ]
}

// export const gridSectionContent = {
//   title: 'Benefits of Shipping And Storage Services',
//   description:
//     'Experience unparalleled convenience and peace of mind with our comprehensive shipping and storage solutions tailored to your unique needs.',
//   cards: [
//     {
//       id: 1,
//       title: 'Cost-Effective',
//       description:
//         'Our services are designed to fit your budget with affordable rates for both short-term and long-term storage needs.',
//       image: {
//         src: '/images/v2/pages/landing-pages/shipping-and-storage-services/cost_effective.svg',
//         alt: 'Cost-Effective'
//       }
//     },
//     {
//       id: 2,
//       title: 'Flexible Plans',
//       description:
//         'Tailored to meet your requirements, whether you need space for a single box or a large inventory of items.',
//       image: {
//         src: '/images/v2/pages/landing-pages/shipping-and-storage-services/flexible_plans.svg',
//         alt: 'Flexible Plans'
//       }
//     },
//     {
//       id: 3,
//       title: 'Global Reach',
//       description:
//         'We partner with leading logistics providers for reliable international shipping, ensuring your items reach any destination safely.',
//       image: {
//         src: '/images/v2/pages/landing-pages/shipping-and-storage-services/global_reach.svg',
//         alt: 'Global Reach'
//       }
//     },
//     {
//       id: 4,
//       title: 'Free Insurance',
//       description:
//         'Every shipment comes with up to $250 of insurance coverage, giving you peace of mind  that your items are protected during transit.',
//       image: {
//         src: '/images/v2/pages/landing-pages/shipping-and-storage-services/free_insurance.svg',
//         alt: 'Free Insurance'
//       }
//     },
//     {
//       id: 5,
//       title: '24/7 Security',
//       description:
//         'Our storage facilities are equipped with cutting-edge security measures, including CCTV surveillance & biometric access systems.',
//       image: {
//         src: '/images/v2/pages/landing-pages/shipping-and-storage-services/security.svg',
//         alt: '24/7 Security'
//       }
//     },
//     {
//       id: 6,
//       title: 'Convenient Pickup',
//       description:
//         'Enjoy the ease of door-to-door service, with scheduled pickups and deliveries according to your convenience.',
//       image: {
//         src: '/images/v2/pages/landing-pages/shipping-and-storage-services/convenient_pickup.svg',
//         alt: 'Convenient Pickup'
//       }
//     }
//   ]
// }

// export const whyChooseUsSectionContent = {
//   title: 'Why Choose ShipAndStorage for Shipping And Storage Services',
//   description:
//     'Trust in our proven expertise and commitment to excellence, ensuring your shipping and storage needs are met with reliability and care.',

//   cards: [
//     {
//       id: 1,
//       title: 'Affordability',
//       description:
//         'Our pricing is transparent and competitive, offering the best value without compromising service quality.',
//       image: {
//         src: '/images/v2/pages/landing-pages/shipping-and-storage-services/affordability.svg',
//         alt: 'Affordability'
//       }
//     },
//     {
//       id: 2,
//       title: 'Security',
//       description:
//         'Your items are stored in state-of-the-art facilities with 24/7 monitoring, biometric access control, and comprehensive security protocols.',
//       image: {
//         src: '/images/v2/pages/landing-pages/shipping-and-storage-services/security2.svg',
//         alt: 'Security'
//       }
//     },
//     {
//       id: 3,
//       title: 'Convenience',
//       description:
//         'We make the process seamless from start to finish, offering flexible storage options, easy booking, and fast delivery.',
//       image: {
//         src: '/images/v2/pages/landing-pages/shipping-and-storage-services/convenience.svg',
//         alt: 'Convenience'
//       }
//     }
//   ]
// }

// export const infoBannerSectionContent = {
//   id: 1,
//   title: 'Fast and Reliable Shipping and Storage Services',
//   description:
//     'Reliable shipping and storage services for all locations. Fast, secure, and affordable solutions tailored to meet your specific storage and shipping needs.',
//   image: {
//     src: '/images/v2/pages/landing-pages/shipping-and-storage-services/fast_and_reliable_Shipping_and_storage_services.svg',
//     alt: 'Fast and Reliable Shipping and Storage Services'
//   },
//   ctaButton: { href: '#', text: 'Get Started' }
// }

// export const faqSectionContent = {
//   title: 'Our Shipping Partners',
//   description:
//     'ShipAndStorage offers world-class Shipping And Storage Services in collaboration with trusted global carriers like FedEx, DHL, and UPS. ',
//   questions: [
//     {
//       id: 1,
//       question: 'FedEx',
//       answer: "Founded by Frederick W. Smith in 1971, FedEx began with just 186 packages and has grown into a global leader in shipping services. Today, FedEx operates a vast fleet of 696 aircraft and 215,000 vehicles, processing 16 million shipments daily to over 220 countries and territories. With more than 550,000 employees and over 5,000 centers worldwide, FedEx guarantees reliable and timely deliveries.|||Disclaimer – FedEx Luggage Shipping Services|||This page was last updated in September 2024 for reference purposes only. FedEx makes no warranties, express or implied, regarding the accuracy or completeness of the information provided."
//     },

//     {
//       id: 2,
//       question: 'DHL',
//       answer: "DHL Express, a prominent division of Deutsche Post DHL Group, is renowned for its international courier, parcel, and express mail services. As a global leader in logistics, DHL handles over 1.8 billion parcels each year. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became fully owned by Deutsche Post in 2002 and now operates in over 220 countries, ensuring its vital role in the global supply chain.|||Disclaimer:||| This page was last updated in September 2024 and is provided for reference purposes only. DHL makes no warranties regarding the accuracy of the information provided."
//     },
//     {
//       id: 3,
//       question: 'UPS',
//       answer: "UPS, originally founded as the American Messenger Company in Seattle in 1907 by teenagers Claude Ryan and Jim Casey, rebranded as United Parcel Service (UPS) in 1919. Today, UPS is one of the largest global shipping companies, delivering 25 million packages daily. With over 500,000 employees worldwide, UPS serves more than 220 countries and territories, offering unmatched global reach.|||Disclaimer:|||This page was last updated in September 2024 for reference purposes only. UPS makes no warranties regarding the accuracy of the information provided. For more details, visit"
//     }
//   ]
// }
